// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrapper":"_8c559fa4c7--avatar-wrapper--siFlZ","type-name-container":"_8c559fa4c7--type-name-container--YQrWa","type":"_8c559fa4c7--type--N9uYr"};